import React from "react";
import BarGraph from "../../../../../components/common/BarGraph";
import DonutChart from "../../../../../components/common/DonutChart";
import NoChartData from "../../../../../components/common/NoChartData/";
import ChartValueCount from  '../../../../Dashboard/StatsBlock/FileChartsBlock/FileChart/ChartValueCount';
import Head from "./Head";
import "./index.scss";

const FileChart = ({
  barColor,
  pie,
  className = "bar-graph",
  headingLabel = "",
  data = [],
  piedata = [],
  handleClick,
  pieChartOptions,
  barGraphOptions
}) => {
  let options = [];
  if (pie) {
    options = pieChartOptions;
  } else {
    options = barGraphOptions;
  }

  return (
    <>
      <div className={`file-chart ${className}`}>
        <Head headingLabel={headingLabel} options={options} _handleClick={handleClick} />
        <div className="inner">
          <div className="inner-bar-graph">
          {/* {data.length === 0 &&  ? <NoChartData /> : data.length === 1 && !loading?  <ChartValueCount data={data}  />: <BarGraph barColor={barColor} data={data}  />} */}
          {pie === false && (  data.length === 0  ?  <NoChartData /> : data.length === 1 ?  <ChartValueCount data={data}  />: <BarGraph barColor={barColor} data={data}  />)}
          {/* {pie === false && (  piedata.length === 0  ?  <NoChartData /> : data.length === 1 ?  <ChartValueCount data={data}  />: <DonutChart  data={piedata}  />)} */}

          </div>
        </div>
      </div>
    </>
  );
};
export default FileChart;
